'use client';

import { useEffect, useState } from 'react';

import { WallType } from '@app-types/config';
import { ProductParentFull } from '@app-types/product';

import { Breadcrumb as BreadcrumbComponent, BreadcrumbElement } from '@components/breadcrumb';

import { paths } from '@helpers/path';

type BreadcrumbProps = {
    type: WallType;
    product: ProductParentFull;
    isRenewal: boolean;
};

export function Breadcrumb({ type, product, isRenewal }: BreadcrumbProps) {
    const [elements, setElements] = useState<BreadcrumbElement[]>([]);

    useEffect(() => {
        const defaultElements: BreadcrumbElement[] = [
            {
                name: 'home',
                label: 'Accueil',
                href: '/',
            },
        ];

        const newElements: BreadcrumbElement[] = [];

        if (type === WallType.PHONE) {
            newElements.push({
                name: 'product type',
                label: 'Téléphone mobile',
                href: isRenewal ? paths.renewalPhoneWall : paths.phoneWall,
            });
            newElements.push({
                name: 'product filter',
                label: `Téléphone ${product.manufacturer}`,
                href: paths.phoneFilter(isRenewal, product.manufacturerCode ?? ''),
            });
        } else if (type === WallType.ACCESSORY) {
            newElements.push({
                name: 'product type',
                label: 'Accessoires',
                href: paths.accessoryWall,
            });
        }

        newElements.push({
            name: 'product title',
            label: product.title,
        });
        setElements([...defaultElements, ...newElements]);
    }, [product]);

    return <BreadcrumbComponent elements={elements} />;
}
